import { UseFormReturn } from 'react-hook-form'
import { z } from 'zod'

import { MarketSummaryDto } from '@/gen/publicApi'

import FormSelect from '@/components/form/formSelect'
import FormSwitch from '@/components/form/formSwitch'

import { cn } from '@/utils/cn'

// eslint-disable-next-line react-refresh/only-export-components
export const yesTemplateSchema = z.object({
    useTemplate: z.literal(true),
    templateMarketCode: z.string(),
})

// eslint-disable-next-line react-refresh/only-export-components
export const noTemplateSchema = z.object({
    useTemplate: z.literal(false),
    templateMarketCode: z.any(),
})

const templateSchema = z.discriminatedUnion('useTemplate', [yesTemplateSchema, noTemplateSchema])

type TemplateSchemaType = z.infer<typeof templateSchema>

interface Props {
    form: UseFormReturn<TemplateSchemaType>
    templateMarketData: MarketSummaryDto[]
}

export default function CreateMarketUseTemplateForm({ form, templateMarketData }: Props) {
    const useTemplate = form.watch('useTemplate')
    return (
        <>
            <FormSwitch control={form.control} name="useTemplate" label="Use an existing template" />
            <FormSelect
                control={form.control}
                name="templateMarketCode"
                label="Template"
                placeholder="Choose a market template"
                options={
                    templateMarketData.map(template => ({
                        value: template.code,
                        label: `${template.name} (${template.code})`,
                    })) || []
                }
                className={cn('mt-4', { hidden: !useTemplate })}
            />
        </>
    )
}
